import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ActiveStepDetails from "../components/planPartials/ActiveStepDetails";
import ScrollToTop from "../components/common/ScrollToTop";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import ChoosePlan from "../components/planPartials/ChoosePlan";
import { useGeneral } from "../components/contexts/GeneralContext";

const SubscribePlanPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <TopStepsStatus
            rightText={"Schools & Nurseries?"}
            url={"/school-nursery"}
          />
          <div className="pt-4 lg:pt-9">
            <ChoosePlan />
          </div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SubscribePlanPage;
